class GTagService {
    constructor() {

    }
    do(command, label, data) {
      if(gtag) {
          gtag(command, label, data);
          //console.log([command,label,data]);
      }  
    }
}

export const gtagService = new GTagService();